import { useLink } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { getLocalizedValue, getProductKeyFromCTType } from "@grandvisionhq/utils";
const useProductLink = (localizedSlug, sku, productType, additionalQueryParams) => {
  const { locale } = useIntl();
  const slug = typeof localizedSlug === "string" ? localizedSlug : getLocalizedValue(localizedSlug, locale);
  const key = getProductKeyFromCTType(productType);
  const query = additionalQueryParams ? new URLSearchParams(additionalQueryParams) : void 0;
  const productLink = useLink({
    route: "products.detail",
    params: {
      slug,
      sku,
      key
    },
    query
  });
  return productLink ? productLink.href : "#";
};
export {
  useProductLink
};
//# sourceMappingURL=use-product-link.js.map
